import * as React from 'react';
import { observer } from 'mobx-react';
import Loader from '../Loader';
import ReportImpl from './ReportImpl';
import ReportStore from '../../ReportStore';

interface Props {
  store: ReportStore;
}

const ReportState: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'ready':
      return (
        <ReportImpl
          report={store.state.reportResource.payload}
          currentDashboardId={store.state.currentDashboardId}
          store={store}
          reportResource={store.state.reportResource}
        />
      );
    case 'error':
      return <></>;
  }
};

export default observer(ReportState);
